function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#F5F5F0;}\r\n\t.st1{fill:#383B54;}\r\n\t.st2{opacity:0.25;fill:#3287BA;stroke:#3287BA;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.5;fill:#383B54;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "-28,-22.9 -22.3,422.9 702.6,422.9 689.7,-22.9 "
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: -5.7,
  y: -78.6,
  className: "st1",
  width: 22.1,
  height: 37
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 18.8,
  y: -116.5,
  className: "st1",
  width: 22.1,
  height: 82.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 43.3,
  y: -138.4,
  className: "st1",
  width: 22.1,
  height: 119.5
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 67.8,
  y: -122,
  className: "st1",
  width: 22.1,
  height: 84
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 92.3,
  y: 154,
  className: "st1",
  width: 22.1,
  height: 72
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 116.8,
  y: -127.7,
  className: "st1",
  width: 22.1,
  height: 79
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 141.3,
  y: 51,
  className: "st1",
  width: 22.1,
  height: 19.5
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 165.8,
  y: 83.5,
  className: "st1",
  width: 22.1,
  height: 37
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 190.3,
  y: 35,
  className: "st1",
  width: 22.1,
  height: 71
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 214.8,
  y: -1,
  className: "st1",
  width: 22.1,
  height: 121.5
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 239.3,
  y: 88,
  className: "st1",
  width: 22.1,
  height: 55
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 263.8,
  y: 169.3,
  className: "st1",
  width: 22.1,
  height: 56.8
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 288.3,
  y: 34.5,
  className: "st1",
  width: 22.1,
  height: 64
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 312.8,
  y: 200,
  className: "st1",
  width: 22.1,
  height: 74.5
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 337.3,
  y: 77,
  className: "st1",
  width: 22.1,
  height: 66
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 361.8,
  y: 55.5,
  className: "st1",
  width: 22.1,
  height: 50.5
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 386.3,
  y: 94.8,
  className: "st1",
  width: 22.1,
  height: 61.8
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 410.8,
  y: -80,
  className: "st1",
  width: 22.1,
  height: 149
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 435.3,
  y: 46,
  className: "st1",
  width: 22.1,
  height: 79.6
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 459.8,
  y: 158,
  className: "st1",
  width: 22.1,
  height: 46.5
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 484.3,
  y: 27.5,
  className: "st1",
  width: 22.1,
  height: 74.5
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 508.8,
  y: 83.5,
  className: "st1",
  width: 22.1,
  height: 48.5
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 533.3,
  y: 178.1,
  className: "st1",
  width: 22.1,
  height: 65.7
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 557.8,
  y: -89.3,
  className: "st1",
  width: 22.1,
  height: 149
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 582.3,
  y: 33.3,
  className: "st1",
  width: 22.1,
  height: 61.5
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 606.8,
  y: 130,
  className: "st1",
  width: 22.1,
  height: 54
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 631.3,
  y: 60,
  className: "st1",
  width: 22.1,
  height: 98
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M0,569.5h647V515c0,0-16.4,1.5-75.2-18s-140.7-99.5-220.5-76.5s-100,86-173.9,110S-25.5,558-25.5,558L0,569.5z"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: -5.7,
  y: 363,
  className: "st3",
  width: 22.1,
  height: 59.5
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 18.8,
  y: 284,
  className: "st3",
  width: 22.1,
  height: 87.5
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 43.3,
  y: 221.2,
  className: "st3",
  width: 22.1,
  height: 37.3
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 67.8,
  y: 339.5,
  className: "st3",
  width: 22.1,
  height: 149
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 92.3,
  y: 267.4,
  className: "st3",
  width: 22.1,
  height: 149
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 116.8,
  y: 243.8,
  className: "st3",
  width: 22.1,
  height: 40.3
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 141.3,
  y: 175,
  className: "st3",
  width: 22.1,
  height: 39
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 165.8,
  y: 267.4,
  className: "st3",
  width: 22.1,
  height: 60.4
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 190.3,
  y: 302.5,
  className: "st3",
  width: 22.1,
  height: 149
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 214.8,
  y: 189.4,
  className: "st3",
  width: 22.1,
  height: 65.1
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 239.3,
  y: 239.8,
  className: "st3",
  width: 22.1,
  height: 44.2
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 263.8,
  y: 307,
  className: "st3",
  width: 22.1,
  height: 34.9
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 288.3,
  y: 189.4,
  className: "st3",
  width: 22.1,
  height: 50.5
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 312.8,
  y: 288.5,
  className: "st3",
  width: 22.1,
  height: 18.5
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 337.3,
  y: 184,
  className: "st3",
  width: 22.1,
  height: 55.8
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 361.8,
  y: 221.2,
  className: "st3",
  width: 22.1,
  height: 62.8
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 386.3,
  y: 325.5,
  className: "st3",
  width: 22.1,
  height: 149
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 410.8,
  y: 269.5,
  className: "st3",
  width: 22.1,
  height: 67
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 435.3,
  y: 293.5,
  className: "st3",
  width: 22.1,
  height: 52.5
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 459.8,
  y: 223.1,
  className: "st3",
  width: 22.1,
  height: 27.9
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 484.3,
  y: 281,
  className: "st3",
  width: 22.1,
  height: 46.8
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 508.8,
  y: 158,
  className: "st3",
  width: 22.1,
  height: 68
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 533.3,
  y: 265,
  className: "st3",
  width: 22.1,
  height: 32.6
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 557.8,
  y: 427,
  className: "st3",
  width: 22.1,
  height: 149
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 582.3,
  y: 434,
  className: "st3",
  width: 22.1,
  height: 60.9
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 606.8,
  y: 410,
  className: "st3",
  width: 22.1,
  height: 54.5
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 631.3,
  y: 446.2,
  className: "st3",
  width: 22.1,
  height: 46.8
});

var SvgNfl = function SvgNfl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647 400",
    style: {
      enableBackground: "new 0 0 647 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNfl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nfl.5f42d0c8.svg";
export { ForwardRef as ReactComponent };